  <div
    class="d-flex flex-column gap-4 align-items-center justify-content-center m-auto"
    style="width: 70%"
  >
    <span
      class="fs-4 text-center text-success fw-semibold"
      style="line-height: 2rem"
      >{{ "app.pageId.settlement.messages.success" | translate }}</span
    >
    <div
      class="bg-primary-light p-2 rounded-circle overflow-hidden d-flex align-items-center justify-content-center"
      style="width: 275px; height: 275px"
    >
      <div
        class="bg-primary p-2 rounded-circle overflow-hidden d-flex align-items-center justify-content-center"
        style="width: 225px; height: 225px"
      >
        <div
          class="bg-primary-dark p-2 rounded-circle overflow-hidden d-flex align-items-center justify-content-center"
          style="width: 175px; height: 175px"
        >
          <icon [icon]="iconCheck" size="100" color="primary-light" />
        </div>
      </div>
    </div>
  </div>